<script>
  import { layoutOption, queryStr, locationInfo, mapLoaded, storeInfos } from '../store/inapp-store'
  import LocationSearch from './LocationSearch.svelte';
  import LocationResetButton from './LocationResetButton.svelte';
  import AzureMapView from './AzureMapView.svelte';
  import LocationInfomation from './LocationInfomation.svelte';

  const urlParams = new URLSearchParams(window.location.search)
  const rtnUrl = urlParams.get('rtn-url')
  const mode = urlParams.get('m')

  $layoutOption.navTitle = '借還杯門市'
  $layoutOption.navBackUrl =  (rtnUrl === null || rtnUrl === undefined) ?`/home${$queryStr}` : rtnUrl
  $layoutOption.showCarousel = false
  $layoutOption.showBanner = false
  $layoutOption.showHome = true
  $layoutOption.showCancel = false
  $mapLoaded = false
  
  let touchable = false 
  let zoomLevel = 15
  let showMapNavbar = mode === 'native'
  let searchLocationInfo = {}
  let selectedStore = null // 選中的門市

  function onChangeLocation(location) {
    $locationInfo.latitude = location.latitude
    $locationInfo.longitude = location.longitude
    zoomLevel = 19
    searchLocationInfo = location
  }

  function onResetLocation(location) {
    $mapLoaded = false
    zoomLevel = 15
    searchLocationInfo = {}
    selectedStore = null // 清空選中的門市，讓附近據點能顯示
  }


  function onStoreSelected(storeData) {
    console.log('Store selected:', storeData)
    selectedStore = storeData
    
    // 設定門市資訊卡需要的數據格式
    searchLocationInfo = {
      ...storeData,
      latitude: storeData.lat,
      longitude: storeData.lon
    }
  }


</script>

<style>
  .azure-map-wrap{
    min-height:calc(100vh + 3.125rem);
  }
</style>

<div class="azure-map-wrap" style="visibility:visible;">
  <AzureMapView {zoomLevel} {showMapNavbar} on:storeSelected={e => onStoreSelected(e.detail)}></AzureMapView>
</div>

<LocationResetButton on:resetLocation={e => onResetLocation(e.detail)}></LocationResetButton>

<!-- 總是載入門市數據，但只在需要時顯示搜尋UI -->
<LocationSearch {touchable} on:changeLocation={e => onChangeLocation(e.detail)} style="{showMapNavbar ? 'display:none;' : ''}"></LocationSearch>


<!-- 底部門市資訊卡（總是顯示，內容依據 selectedStore 決定） -->
<LocationInfomation {searchLocationInfo} />

<input type="hidden" class="w-100" id="permission">
<input type="hidden" class="w-100" id="latitude">
<input type="hidden" class="w-100" id="longitude">